import script from "./ProjectLiberty.vue?vue&type=script&setup=true&lang=js"
export * from "./ProjectLiberty.vue?vue&type=script&setup=true&lang=js"

import "./ProjectLiberty.vue?vue&type=style&index=0&id=73bfc2d7&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-73bfc2d7"]])

export default __exports__